import { Link } from "react-router-dom";
import footerLogo from "../Assest/bingopay_new_golden_removebg.png";

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-3 gap-8">

        {/* Brand */}
        <div>
          <img
            src={footerLogo}
            alt="BingoPays"
            className="h-10 mb-3"
          />

          <p className="text-sm text-gray-400">
            © 2026 Powered by <br />
            <span className="text-gray-200 font-medium">
              SHREEBALAJEE CONNECT PVT. LTD.
            </span>
          </p>

          <p className="text-sm mt-3">
            Trusted digital payment & financial service platform.
          </p>
        </div>

        {/* Company / Policies */}
        <div>
          <h3 className="text-white font-semibold mb-3">
            Company & Policies
          </h3>
          <ul className="space-y-2 text-sm">
            <li>
              <Link to="/about" className="hover:text-white"  onClick={() => window.scrollTo(0, 0)}>
                About Us
              </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-white"  onClick={() => window.scrollTo(0, 0)}>
                Contact Us
              </Link>
            </li>

            <li>
              <Link to="/privacypolicy" className="hover:text-white"  onClick={() => window.scrollTo(0, 0)}>
              
                Our Policies
              </Link>
            </li>
            <li>
              <Link to="/terms" className="hover:text-white"  onClick={() => window.scrollTo(0, 0)}>
                Terms & Conditions
              </Link>
            </li>
            <li>
              <Link to="/userpolicy" className="hover:text-white">
                User policies
              </Link>
            </li>
            {/* <li>
              <Link to="/disclaimer" className="hover:text-white">
                Disclaimer
              </Link>
            </li> */}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h3 className="text-white font-semibold mb-3">Contact</h3>
          <p className="text-sm">📧 info@bingopays.in</p>
          <p className="text-sm mt-2">📞 +91 8586 036 036</p>
        </div>

      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700 text-center text-sm py-4 text-gray-400">
        © {new Date().getFullYear()} BINGOPAY. All rights reserved.
      </div>
    </footer>
  );
}
